<template>
  <div id="mauticform_wrapper_marsroadmap202108'" class="my-4">
    <input v-if="currentName" id="mauticform_marsroadmap202108_preferenza" type="hidden" name="mauticform[preferenza]" :value="currentName">
    <div id="mauticform_marsroadmap202108_submit" class="mauticform-row mauticform-button-wrapper mauticform-field-2">
      <button id="mauticform_input_marsroadmap202108_submit" type="submit" name="mauticform[submit]" value="" class="mauticform-button btn btn-default px-0" @click="setPreference">
        <img class="pointer" :src="status ? LikeOn : LikeOff">
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import LikeOn from '~/assets/img/pricing/like-on.svg'
import LikeOff from '~/assets/img/pricing/like-off.svg'

// Props
const props = withDefaults(defineProps<{
  name: string
}>(), {
  name: ''
})

const currentName = ref('')
const cookieRoadmap = useCookie<string[]>(
  'roadmapLiked',
  {
    default: () => [],
    watch: true
  }
)

function setPreference() {
  currentName.value = props.name
  storePreference()
  setTimeout(() => {
    currentName.value = ''
  }, 500)
}
function storePreference() {
  cookieRoadmap.value = [props.name, ...cookieRoadmap.value]
}
const status = computed( ()=> {
  const isLiked = cookieRoadmap.value.indexOf(props.name) != -1
  // console.log('roadmapLiked[' + props.name + ']', isLiked)
  return isLiked
})
</script>

<style>
</style>
